import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Home,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'index',
        component: () =>
          import(/* webpackChunkName: "index" */ '@/views/homePage/index.vue')
      },
      {
        path: 'production',
        redirect: '/production/ssLive',
        component: () => import(/* webpackChunkName: "production" */ '@/views/production/index.vue'),
        children: [
          {
            path: 'shuangshi',
            name: 'shuangshi',
            component: () => import(/* webpackChunkName: "shuangshi" */ '@/views/production/ssLittle.vue')
          },
          {
            path: 'ssLive',
            name: 'ssLive',
            component: () => import(/* webpackChunkName: "ssLive" */ '@/views/production/ssLive.vue')
          },
          {
            path: 'ai',
            name: 'ai',
            component: () => import(/* webpackChunkName: "ai" */ '@/views/production/ai.vue')
          },
          {
            path: 'content',
            name: 'content',
            component: () => import(/* webpackChunkName: "content" */ '@/views/production/content.vue')
          },
          {
            path: 'learningmachine',
            name: 'learningmachine',
            component: () => import(/* webpackChunkName: "learningmachine" */ '@/views/production/learningmachine.vue')
          },
          {
            path: 'weclassroom',
            name: 'weclassroom',
            component: () => import(/* webpackChunkName: "weclassroom" */ '@/views/production/weclassroom.vue')
          },
          {
            path: 'accomplishment',
            name: 'accomplishment',
            component: () => import(/* webpackChunkName: "accomplishment" */ '@/views/production/accomplishment.vue')
          },
          {
            path: 'libu',
            name: 'libu',
            component: () => import(/* webpackChunkName: "libu" */ '@/views/production/libu.vue')
          }
        ]
      },
      {
        path: 'download',
        name: 'downloadCenter',
        component: () => import(/* webpackChunkName: "downloadCenter" */ '@/views/downloadCenter')
      },
      {
        path: 'about_us',
        redirect: '/about_us',
        component: () => import(/* webpackChunkName: "abouts_us_wrapper" */ '@/views/aboutUs/wrapper.vue'),
        children: [
          {
            path: '',
            name: 'aboutUs',
            component: () => import(/* webpackChunkName: "abouts_us" */ '@/views/aboutUs/index.vue')
          },
          {
            path: 'news_center',
            redirect: '/about_us/news_center/list',
            component: () => import(/* webpackChunkName: "NewCenter" */ '@/views/aboutUs/newsCenter'),
            children: [
              {
                path: 'list',
                name: 'newsList',
                component: () => import(/* webpackChunkName: "NewsList" */ '@/views/aboutUs/newsCenter/list')
              },
              {
                path: 'detail',
                name: 'newsDetail',
                component: () => import(/* webpackChunkName: "NewDetail" */ '@/views/aboutUs/newsCenter/detail')
              }
            ]
          }
        ]
      },
      {
        path: 'success-info',
        name: 'successInfo',
        component: () => import(/* webpackChunkName: "successInfo" */ '@/views/successInfo/index.vue')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "register" */ '@/views/register')
      }
    ]
  }
];

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
